/**
 * QRScanner (Zxing) Plugin
 * Real-time webcam-driven HTML5 QR code scanner
 * github repo: https://github.com/zxing-js/library
 */

var QRScanner = function(element, options){
    this.element = element;
    this.$element = $(element);
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

QRScanner.prototype = {

    // shorthand for using prototype
    constructor : QRScanner,

    // default options
    defaults : {
        previewWidth : 640,
        onScan : function(content, result){},
        onScanError : function(error){ console.log(error) }
    },

    isActive: false,
    permissionsPrompted : false,

    // storage for ZXing Scanner object
    Scanner : null,

    // storage for video devices
    devices : [],

    // storage for DOM elements
    $preview : null,
    $scanTrigger : null,

    init : function(){
        var _this = this;

        _this.$preview = _this.$element.find('.js-qrcode-video');
        _this.$scanTrigger = _this.$element.find('.js-qrcode-start-scan');

        // TODO : add some browser support validation as well
        if ( ZXing ) {
            _this.isActive = true;

            // store the plugin on this object
            _this.Scanner = new ZXing.BrowserQRCodeReader();

            _this.Scanner
                .getVideoInputDevices()
                .then(function(videoInputDevices){
                    _this.devices = videoInputDevices;

                    if ( _this.devices.length === 0 ) {
                        _this.devices = [
                            {
                                'deviceId' : '0',
                                'label' : 'No Devices Found',
                                'disabled' : true
                            }
                        ]
                    }

                    // TODO : provide a list of selectable devices
                    _this.devices.forEach(function(device){
                        _this.$element.find('.js-qrcode-devices').append('<option value="' + device.deviceId + '" ' + ( device.disabled ? 'disabled' : null ) + '>' + device.label + '</option>');
                    });
                })
                .catch(function(err){ console.error(err)});



            // display the button and preview
            _this.$element.removeClass('hide-content');

            _this.$preview.add( _this.$element.find('.js-qrcode-video-container') )
                    .css({ 'width' : _this.settings.previewWidth + 'px' });

            // start scanning
            _this.$scanTrigger.on('click', function(e){

                // start scanning
                _this.startScan(_this.devices[0].deviceId, _this.$preview.attr('id'));

                e.preventDefault();
            });

            // implement reset button
            $(_this.$element.find('.js-qrcode-reset-scan')).on('click', function() {
                _this.stopScan();
                console.log('Reset.');
                _this.startScan( _this.$element.find('.js-qrcode-devices').val(), _this.$preview.attr('id') );
            });

            // TODO : event binding for video selection
            $(_this.$element.find('.js-qrcode-devices')).on('change', function(){
                _this.stopScan();

                _this.startScan($(this).val(), _this.$preview.attr('id'));
            });
        } else {
            console.log('ZXing library is required.');
        }
    },

    startScan : function(deviceId, preview){
        var _this = this,
            deviceId = deviceId,
            preview = preview || _this.$preview.attr('id');

        if ( _this.devices.length > 0 && typeof deviceId === 'undefined' ) {
            deviceId = _this.devices[0].deviceId;
        }

        return _this.Scanner
            .decodeFromInputVideoDevice(deviceId, preview)
            .then(function(result){
                _this.settings.onScan.call(_this, result.text, result);
            }).catch(function(error){
                // the user may have denied permissions, let's re-ask
                if ( error.name == 'OverconstrainedError' && ! _this.permissionsPrompted ) {
                    _this.promptPermissions()
                        .then(function(stream) {
                            _this.settings.onScanError.call(_this, {
                                name : 'QgivPermissionGranted'
                            });
                        }).catch(function(error) {
                            // error: PERMISSION_DENIED
                            _this.settings.onScanError.call(_this, error);
                        });
                }
                _this.settings.onScanError.call(_this, error);
            });
    },

    stopScan : function () {
        var _this = this;

        if (_this.Scanner) {
            _this.Scanner.reset();
        }
    },

    promptPermissions: function () {
        const _this = this;
        _this.permissionsPrompted = true;
        return navigator.mediaDevices.getUserMedia({
            video: true,
            audio: false,
        });
    },

    enumerateVideoSources: async function () {
        const $cameraOptionsSelect = $('.js-qrcode-devices');

        if (
            navigator &&
            navigator.mediaDevices &&
            typeof navigator.mediaDevices.enumerateDevices === "function"
        ) {
            try {
                // -------------------------------------------------------------------------
                // NOTE: In order to see devices on mobile Safari, we MUST request permissions immediately prior.
                // We can only request permissions by opening a generic stream with getUserMedia(), so
                // below we open that stream, enumerate the available devices, and then close the stream.
                // -------------------------------------------------------------------------
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                    audio: false,
                });
                let devices = await navigator.mediaDevices.enumerateDevices();
                const cameras = devices.filter((device) => {
                    return device.kind === "videoinput";
                });

                // We have permissions now, so close generic stream;
                const tracks = stream.getTracks();
                if (tracks) {
                    for (let i = 0; i < tracks.length; i++) {
                        tracks[i].stop();
                    }
                }
                const options = cameras.map((camera) => {
                    return `<option value="${camera.deviceId}">${camera.label}</option>`;
                });
                $cameraOptionsSelect.empty();
                $cameraOptionsSelect.append('<option value="" selected>Select Camera</option>');
                options.forEach((option) => {
                    $cameraOptionsSelect.append(option);
                });

            } catch (error) {
                // Permissions were denied, or otherwise could not be granted.
                console.error(error.name, error.message);
                return { cameras: [] };
            }
        } else {
            throw "Devices unavailable. Please try again.";
        }
    },

    destroy: function() {
        var _this = this;
        if ( ZXing && _this.isActive ) {

            if (_this.Scanner) {
                _this.stopScan();
                _this.Scanner = null;
            }

            _this.$element.addClass('hide-content');
            _this.$scanTrigger.off();
            _this.$element.removeData('qg_qrscanner');
        }
    }
};

$.fn.qrscanner = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_qrscanner" ) ) {
            $.data( this, "qg_qrscanner", new QRScanner( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};
